export const checkoutSteps = [
  'billingData',
  'addressSelection',
  'paymentMethod'
]